<template>
  <div>
    <v-layout wrap>
      <v-flex >
        <c-search-form
            :rows-per-page-items="1000"
            :page-size="1000"
            :form-name="formName"
            :fields="fields"
            :hiddenFields="hiddenFields"
            key-property="missionReviewId"
            :search-url="search_url"
            create-url="/babiMissionReview/save"
            delete-url="/babiMissionReview/delete"
            form-type="intable"
            custom-create-new
            @createNew="openCreateDialog"
            custom-edit-item
            @editItem="openCreateDialog"
            ref="tableData"
            :reload="timeReload"
            :deleteMulti="false"
            :acceptDelete="false"
            :acceptView="false"
            :accept-create="false"
            @viewItem="viewItem"
            @setLastSearchValues="setLastSearchValues"
            :lastSearchValues="lastSearchValues"
            orderBy="asc,desc"
            :acceptBack="3001"
            @copyMission="copyMission"
        >
        </c-search-form>
        <material-type-group-create
            :propsItem="category"
            :cDialog="visibleCreateDialog"
            @closeCreateDialog="closeCreateDialog"
            :formCreateName="formCreateName"
            :hiddenFields="hiddenFields"
        />
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import {areaContants} from "@/constants";
import axios from "axios";
import MaterialTypeGroupCreate from "@/views/admin/babiclass_point_account/MissionReviewCreate";
import {message} from "@/shared/message";

export default {
  name: "warehouse",
  components: {MaterialTypeGroupCreate, CSearchForm},
  data: () => {
    return {
      formName: "BabiClass Nhiệm vụ theo Zalo Phụ Huynh",
      formCreateName: "Thêm mới lớp học",
      category: null,
      visibleCreateDialog: false,
      timeReload: 0,
      allAcount: 0,
      hiddenFields: {
        typeId: "0",
      },
      fields: [
        {
          value: "index",
          text: "lang.common.index",
          sortable: false,
          headerStyle: "text-align:center; width: 40px;",
        },
        {
          value: 'listDate',
          text: 'Ngày list',
          sortable: false,
          search: true,
          headerStyle: "text-align:center; width:100px;",
        },
        {
          value: 'listDatePhVideo',
          text: 'Ngày phụ huynh gửi video',
          search: true,
          sortable: false,
          headerStyle: "text-align:center; width: 100px;",
        },
        {
          value: 'listTeacher',
          text: 'Giáo viên list',
          search: true,
          sortable: false,
          headerStyle: "text-align:center; width: 100px;",
        },
        {
          value: 'classId',
          text: 'Tên lớp',
          sortable: false,
          search: true,
          headerStyle: "text-align:center; width: 230px;",
          type: "select",
          name: "classId",
          items: [],
          itemText: "className",
          itemValue: "classId",
        },
        {
          value: 'classLink',
          text: 'Link zalo lớp',
          type: "link",
          search: true,
          sortable: false,
          headerStyle: "text-align:center; width: 180px;",
        },
        {
          value: 'accountZaloName',
          text: 'Hà Anh',
          search: true,
          sortable: false,
          headerStyle: "text-align:center; width: 70px;",
        },
        {
          value: 'zaloPh',
          text: 'Tên zalo PH',
          search: true,
          sortable: false,
          headerStyle: "text-align:center; width: 100px;",
        },
        {
          value: 'type',
          text: 'Type',
          search: true,
          sortable: false,
          headerStyle: "text-align:center; width: 50px;",
        },
        {
          value: 'linkVideo',
          text: 'Link bài tập',
          sortable: false,
          type: "link",
          search: true,
          headerStyle: "text-align:center; width: 350px;",
        },
        {
          value: 'dateReview',
          text: 'Ngày nhận xét',
          sortable: false,
          search: true,
          dateFormat: 'dd/MM/yyyy',
          headerStyle: "text-align:center; width: 60px;",
        },
       /* {
          value: "custom_action_list",
          text: "Phân công",
          headerStyle: "text-align:center; width: 50px;",
          items: [
            {
              text: "Nội dung nhiệm vụ thứ 5",
              icon: "account_circle",
              event: "assignment",
              color: "primary"
            },
          ],
        },*/
        /*        {
                  value: 'teacherReview',
                  text: 'Giáo viên nhận xét',
                  sortable: false,
                  search: true,
                  headerStyle: "text-align:center; width: 70px;",
                },*/
        {
          value: 'userId',
          text: 'Giáo viên nhận xét',
          sortable: false,
          search: true,
          headerStyle: "text-align:center; width: 200px;",
          type: "select",
          name: "userId",
          items: [],
          itemText: "userName",
          itemValue: "userId",
        },
        {
          value: 'missionId',
          text: 'Nhiệm vụ',
          sortable: false,
          search: true,
          headerStyle: "text-align:center; width: 200px;",
          type: "select",
          name: "missionId",
          items: [],
          itemText: "missionName",
          itemValue: "missionId",
        },
        {
          value: 'noteReview',
          text: 'Nhận xét',
          sortable: false,
          search: true,
          headerStyle: "text-align:center; width: 300px;",
        },
        {
          value: "custom_action_list",
          text: "Copy nhận xét",
          headerStyle: "text-align:center; width: 50px;",
          items: [
            {
              text: "Copy nhận xét",
              icon: "file_copy",
              event: "copyMission",
              color: "primary"
            },
          ],
        },
        /*{
          value: "custom_action_list",
          text: "Đã gửi text và voice",
          headerStyle: "text-align:center; width: 50px;",
          items: [
            {
              text: "Đã gửi text và voice",
              icon: "check",
              event: "sendTextVoice",
              color: "primary"
            },
          ],
        },*/
        {
          value: 'dateSendReview',
          text: 'Ngày gửi ',
          sortable: false,
          search: true,
          dateFormat: 'dd/MM/yyyy',
          headerStyle: "text-align:center; width: 60px;",
          //type: "datepicker"
        },
        {
          value: 'teacherSend',
          text: 'Giáo viên gửi',
          sortable: false,
          search: true,
          headerStyle: "text-align:center; width: 50px;",
        },
        /*{
          value: "action",
          text: "lang.common.actions",
          sortable: false,
          compound: true,
          width: "10%",
          headerStyle: "text-align:center",
        },*/
      ],
    };
  },

  created() {
    this.search_url = "/babiMissionReviewCheck/search/"+ this.$route.params.id;

    axios.post(
        process.env.VUE_APP_API_URL + "/babiClass/listAllName", {status: 1}
    )
        .then(
            (data) => {
              let itemFields = this.fields.filter(function (e) {
                return e.name == "classId";
              });
              if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = data;
              }
            }
        );

    axios.post(
        process.env.VUE_APP_API_URL + "/babiMission/listAllName", {status: 1}
    )
        .then(
            (data) => {
              let itemFields = this.fields.filter(function (e) {
                return e.name == "missionId";
              });
              if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = data;
              }
            }
        );

    axios.post(
        process.env.VUE_APP_API_URL + "/user/listAllName", {status: 1}
    )
        .then(
            (data) => {
              let itemFields = this.fields.filter(function (e) {
                return e.name == "userId";
              });
              if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = data;
              }
            }
        );
  },

  methods: {

    openCreateDialog: function (item = null) {
      if (item == null) {
        this.formCreateName = '';
        this.getNextCode();
      } else {
        this.category = item;
        this.formCreateName = 'Cập nhật nhiệm vụ tuần';
        this.visibleCreateDialog = true;
      }
    },
    closeCreateDialog: function () {
      this.category = null;
      this.visibleCreateDialog = false;
      this.timeReload = Math.floor(Math.random() * 100);
    },

    getNextCode: function () {
      axios.get(
          process.env.VUE_APP_API_URL +
          "/autoIncrease/getNextNumber?type=MATERIAL_TYPE_ALLY"
      )
          .then((data) => {
            this.category = Object.assign({}, this.category, {"categoryCode": "MATERIAL_TYPE_ALLY" + data, "status": 1})
            this.visibleCreateDialog = true;
          });
    },
    setLastSearchValues: function (values) {
      //this.lastSearchValues = Object.assign(this.lastSearchValues, {"searchQT":JSON.stringify(values)});
      this.lastSearchValues = Object.assign(this.lastSearchValues, values);
    },
    createParamLastSearch: function (values) {
      const obj1 = {
        searchImportRequest: JSON.stringify(values),
      };
      const obj2 = this.$route.query;
      return {...obj1, ...obj2};
    },
    viewItem: function (item) {
      this.$router.push({
        path: '/program/view/' + item.programId, query: this.createParamLastSearch(this.lastSearchValues)
      });
    },
    copyMission(item) {
      axios
          .post(
              process.env.VUE_APP_API_URL +
              "/babiMissionReviewCheck/copyMission/" + item.missionReviewId
          )
          .then(
              (data) => {
                console.info(data.items[0].noteReview)
                if (data != null && data.items != null && data.items[0].noteReview != null) {
                  this.mytextMessge = data.items[0].noteReview;
                  this.copyURL1(this.mytextMessge);
                } else {
                  message.error(this.$t("Không thể copy nội dung"));
                }
              },
              (error) => {
                console.log(error);
              }
          );
    },

    sendTextVoice(item) {
      axios
          .post(
              process.env.VUE_APP_API_URL +
              "/babiMissionReviewCheck/updateStatusReview/" + item.missionReviewId
          )
          .then(
              (data) => {
                if (data.responseCode == "0") {
                  message.success(
                      this.$t("Đã gửi text và voice ")
                  )
                  this.closeCreateDialog();
                } else {
                  message.error(this.$t(data.description));
                }
              },
              (error) => {
                console.log(error);
              }
          );

    },

    assignment(item) {
      axios
          .post(
              process.env.VUE_APP_API_URL +
              "/babiMissionReviewCheck/assignmentNote/" + item.missionReviewId
          )
          .then(
              (data) => {
                if (data.responseCode == "0") {
                  message.success(
                      this.$t("Phân công nhận xét thành công ")
                  )
                  this.closeCreateDialog();
                } else {
                  message.error(this.$t(data.description));
                }
              },
              (error) => {
                console.log(error);
              }
          );

    },

  },

  destroyed() {
  },
};
</script>
